import { Component } from '@angular/core';
import {ChargesPage} from "./charges/charges";
import {PaymentsPage} from "./payments/payments";
import {OrdersPage} from "./orders/orders";

@Component({
  selector: 'page-pay',
  templateUrl: 'pay.html',
})
export class PayPage {
  tab1;
  tab2;
  tab3;
  constructor() {
    this.tab1 = OrdersPage;
    this.tab2 = PaymentsPage;
    this.tab3 = ChargesPage;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PayPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/pay/pay.ts